import React, { useEffect } from 'react';
import styled from '@emotion/styled';
import { useSelector, useDispatch } from 'react-redux';
import { showModal } from '../../../../actions/modal';

import Pallets from './Pallets';
import Packings from './Packings';
import PackingMarketplaceBadge from './PackingMarketplaceBadge';

import SpinnerBlock from '../../../common/SpinnerBlock';
import Toogle from '../../../common/Toogle';
import { useState } from 'react';
import { fetchPostFbmDeliveryQrCode } from '../../../../actions/orders';

import { fetchGetWorksheetFormTemplate } from '../../../../actions/orders';

const Wrapper = styled('div')`
  padding-left: 0;
  padding-right: 0;
  font-size: 13px;
  > div {
    padding-left: 1.5rem;
    padding-right: 1.5rem;
    padding-bottom: 10px;
    &:last-child {
      padding-bottom: 0;
    }
  }
  .card-title {
    padding-top: 4px;
    padding-bottom: 13px;
  }
  .header-title {
    font-size: 16px;
  }
  .tip-wrap {
    position: relative;
    .tip-plus {
      height: 17px;
      width: 17px;
      display: flex;
      justify-content: center;
      align-items: center;
      border: 1px solid #72747b;
      border-radius: 50%;
      margin-right: 5px;
      cursor: pointer;
    }
    .tip {
      position: absolute;
      left: -10px;
      top: -35px;
      background: white;
      border-radius: 2px;
      border: 1px solid #ebebeb;
      padding: 3px 7px;
      z-index: 1;
      &::before {
        content: '';
        position: absolute;
        bottom: -5px;
        left: 10px;
        height: 10px;
        width: 10px;
        background: white;
        transform: rotate(45deg);
        z-index: 0;
      }
    }
  }
  .packing-video-block {
    margin-top: -2px;
    margin-left: auto;
    display: flex;
    i {
      font-size: 20px;
      margin-right: 10px;
    }
    a {
      display: block;
      color: #4fc6e1;
      text-decoration: underline;
    }
  }
  .packings-wrapper {
    > div {
      padding: 12px;
      background: #f6f8f9;
      border: 1px solid #e0e9ee;
      box-sizing: border-box;
      border-radius: 4px;
      color: #72747b;
      margin-bottom: 12px;
      &:last-child {
        margin-bottom: 0;
      }
      .parameters {
        margin-top: 4px;
      }
      .pallet-weight,
      .packing-quantity {
        min-width: 81px;
        display: flex;
        justify-content: flex-end;
        font-weight: 500;
      }
      .pallet-item,
      .packing-item {
        margin-top: 10px;
        &:first-child {
          margin-top: 2px;
        }
      }
      .packing-top {
        display: flex;
        align-items: flex-start;
        flex-wrap: wrap;
        justify-content: space-between;

        .pallet-barcode {
          margin-top: 13px;
          font-weight: 500;
          margin-right: 24px;
        }

        .show-packing-info-button {
          display: flex;
          align-items: center;
          margin-top: 12px;
          cursor: pointer;
          font-weight: 500;
          i {
            font-size: 20px;
            margin-left: 4px;
            cursor: pointer;
          }
        }
      }
      .packing-items {
        margin-top: 12px;
        border-top: 1px solid #ebebeb;
        padding-top: 12px;
        > div {
          display: flex;
        }
      }
    }
    .show-packing-info-button {
      display: flex;
      align-items: center;
      cursor: pointer;
      font-weight: 500;
      i {
        font-size: 20px;
        margin-left: 4px;
        cursor: pointer;
      }
    }
  }

  .packing-item {
    justify-content: space-between;
    flex-wrap: wrap;
    @media (max-width: 1500px) and (min-width: 1300px) {
      flex-direction: column;
      .packing-item-right {
        flex-direction: column;
        .packing-quantity {
          margin-left: 0;
          width: auto;
          justify-content: flex-start;
        }
      }
    }
    @media (max-width: 1200px) and (min-width: 1025px) {
      flex-direction: column;
      .packing-item-right {
        flex-direction: column;
        .packing-quantity {
          margin-left: 0;
          width: auto;
          justify-content: flex-start;
        }
      }
    }
    @media (max-width: 500px) {
      flex-direction: column;
      .packing-item-right {
        flex-direction: column;
        .packing-quantity {
          margin-left: 0;
          width: auto;
          justify-content: flex-start;
        }
      }
    }
  }

  .pallet-item {
    flex-wrap: wrap;
    display: flex;
    justify-content: space-between;
  }

  .pallet-item-barcode {
    margin-top: 4px;
    margin-right: 15px;
  }

  .packing-item-name {
    margin-right: 15px;
    font-weight: 500;
    margin-bottom: 2px;
    max-width: 450px;
    @media (max-width: 1610px) {
      max-width: 300px;
    }
    @media (max-width: 1500px) {
      max-width: 250px;
    }
  }

  .packing-item-right {
    display: flex;
  }

  .packing-item-left {
    display: flex;
  }

  .packing-quantity {
    margin-left: 24px;
  }

  .packing-main {
    > div:last-child {
      .show-packing-info-button {
        margin-top: 12px;
      }
      .pallet-barcode {
        margin-top: 13px;
      }
    }
  }

  .packing-right {
    display: flex;
    .pallet-barcode {
      display: flex;
      align-items: center;
    }
  }

  .packing-item-string {
    display: flex;

    p {
      max-width: 100%;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      margin: 0 -13px 0 0;
      transition: 0.15s;
    }

    .fe-copy {
      align-self: center;
      cursor: pointer;
      opacity: 0;
      transition: 0.15s;
    }

    &:hover {
      p {
        max-width: calc(100% - 21px);
        margin: 0 8px 0 0;
      }

      .fe-copy {
        opacity: 1;
      }
    }
  }

  .equipment-headergroup {
    display: flex;
    align-items: center;
    justify-content: space-between;
    @media (max-width: 800px) {
      align-items: start;
      flex-direction: column;
    }
    .equipment-headerblock {
      display: flex;
      align-items: center;
      @media (max-width: 800px) {
        align-items: start;
        flex-direction: column;
      }
      button {
        margin-left: 8px;
      }
      .header-title {
        margin-right: 8px;
      }
      .ti-download {
        margin-right: 10px;
      }
    }

    .header-title {
      margin: 0;
    }

    .header-equipment {
      justify-content: space-between;
      width: 100%;
    }

    .qr-toggler-wrap {
      display: flex;
    }

    .qr-toggler-title {
      margin-right: 10px;
    }
  }
`;

const QrToggler = ({ fbmWithFile, orderId }) => {
  const [checked, setChecked] = useState(false);

  const dispatch = useDispatch();

  const handleQrToggler = (value) => {
    setChecked(value);
    handleQrCodeDelivery(value);
  };

  const handleQrCodeDelivery = async (value) => {
    const body = {
      id: orderId,
      useFile: value,
    };

    const res = await dispatch(fetchPostFbmDeliveryQrCode(body));

    if (res.success) {
      dispatch(fetchGetWorksheetFormTemplate(orderId));
    }
  };

  useEffect(() => {
    setChecked(fbmWithFile);
  }, [fbmWithFile]);

  return (
    <div className="qr-toggler-wrap">
      <h6 className="qr-toggler-title">QR Поставка</h6>
      <Toogle
        id="qrToggler"
        onChange={(e) => handleQrToggler(e.target.checked)}
        checked={checked}
      />
    </div>
  );
};

const PackingsBlock = (props) => {
  const { currentOrder, actualizeOrder, loadingPackings, requirements } = props;
  const { packings, pallets, delivery, id, fbmWithFile } = currentOrder;

  const deliveryInfo = useSelector((state) => state.orders.deliveryInfo);
  const currentDelivery = deliveryInfo?.find((info) => info.code === delivery.code);
  const deliveryFbmType = currentDelivery.fbmType;
  const isFboDeliveryByCactus = currentDelivery.fboDeliveryByCactus;

  const dispatch = useDispatch();

  const handleImportAddMarkers = () => {
    dispatch(
      showModal('ImportAddMarkers', {
        currentOrder,
        requirements,
        submitCallback: () => actualizeOrder(currentOrder.id),
      }),
    );
  };

  return (
    <Wrapper className="card-box packing">
      <SpinnerBlock show={loadingPackings} />
      <div style={{ display: 'flex' }} className="card-title equipment-headergroup">
        <div className="equipment-headerblock header-equipment">
          <h4 className="header-title">Комплектация</h4>
          <PackingMarketplaceBadge
            packings={currentOrder.packings}
            requirements={requirements}
            pallets={currentOrder.pallets}
          />
          {deliveryFbmType === 'WILDBERRIES' && isFboDeliveryByCactus ? (
            <QrToggler fbmWithFile={fbmWithFile} orderId={id} />
          ) : null}
        </div>

        {deliveryFbmType === 'OZON' ? (
          <div className="equipment-headerblock">
            <div className="info"></div>
            <span className="help-tooltip-wrapper">
              <i className="fe-help-circle" />
              <span className="help-tooltip">Быстрое массовое прикрепление стикеров мест</span>
            </span>
            <button type="button" className="btn btn-light" onClick={handleImportAddMarkers}>
              <i className="ti-download" /> Импорт доп маркировки
            </button>
          </div>
        ) : null}

        {currentOrder.packingVideos && currentOrder.packingVideos.length ? (
          <div className="packing-video-block">
            <i className="fe-video" />
            <div>
              {currentOrder.packingVideos.map((v, i) => (
                <a key={v} href={v} target="_blank" rel="noopener noreferrer">{`Видео упаковки ${
                  i ? i + 1 : ``
                }`}</a>
              ))}
            </div>
          </div>
        ) : null}
      </div>

      <div className="border-top pt-3">
        {packings?.length ? <Packings {...props} /> : null}

        {pallets?.length ? (
          <div style={{ marginTop: pallets?.length ? '16px' : 0 }}>
            <Pallets requirements={requirements} {...props} />
          </div>
        ) : null}
      </div>
    </Wrapper>
  );
};

export default PackingsBlock;
